import { render, staticRenderFns } from "./associados.vue?vue&type=template&id=5d90b81c&scoped=true&"
import script from "./associados.vue?vue&type=script&lang=js&"
export * from "./associados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90b81c",
  null
  
)

export default component.exports